import { Injectable, inject } from '@angular/core';

import { BetBuilderConfig } from '@frontend/sports/common/client-config-data-access';

import { ISlip } from '../../../../../bet-generation/models';
import { GroupPickHasLiveLegsError } from '../../../../errors/general/group-pick-error';
import { BetBuilderSlipValidationContext } from '../../../../models/models';
import { isGroupPickWithRestrictedLiveLegs } from '../../../utils/bet-builder-utils';
import { IBetBuilderSlipValidator } from '../validators';

@Injectable()
export class GroupPickHasLiveLegsSlipValidator implements IBetBuilderSlipValidator<GroupPickHasLiveLegsError> {
    private readonly betBuilderConfig = inject(BetBuilderConfig);

    validate(_: ISlip, context: BetBuilderSlipValidationContext): Iterable<GroupPickHasLiveLegsError> {
        const invalidBetBuilderPickIds = context.picks
            .filter((p) => isGroupPickWithRestrictedLiveLegs(this.betBuilderConfig.liveBetBuilderEnabledCompetitions, p))
            .map((p) => p.id);

        return invalidBetBuilderPickIds.length ? [new GroupPickHasLiveLegsError(invalidBetBuilderPickIds)] : [];
    }
}
